import React, { useState, useEffect } from "react";
import ContactForm from "./ContactForm";
import "../styles/Contacto.css";

const Contacto = ({ traducciones }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Detecta si la pantalla es móvil
    };

    handleResize(); // Ejecuta al cargar
    window.addEventListener("resize", handleResize); // Escucha cambios de tamaño

    return () => window.removeEventListener("resize", handleResize); // Limpia el evento
  }, []);

  return (
    <div className="contacto-container">
      {isMobile ? (
        // Versión móvil
        <>
          <div className="foto-titulo-container">
            <div className="foto-contacto">
              <div className="titulo-contacto">
                {traducciones.contacto
                  ? traducciones.contacto.titulo
                  : "CONTACTO"}
              </div>
            </div>
          </div>
          <div className="correo-contacto text-center">
            info@opmsconsulting.com<br></br>
            +57 3014645301
          </div>
          <div className="formulario-centro">
            <ContactForm traducciones={traducciones}></ContactForm>
          </div>
        </>
      ) : (
        // Versión no móvil
        <>
          <div className="foto-contacto text-start">
            <div className="formulario-centro">
              <div className="titulo-contacto text-start">
                {traducciones.contacto
                  ? traducciones.contacto.titulo
                  : "CONTACTO"}
              </div>
              <ContactForm traducciones={traducciones}></ContactForm>
            </div>
          </div>
          <div className="correo-contacto text-start">
            info@opmsconsulting.com<br></br>
            +57 3014645301
          </div>
        </>
      )}
    </div>
  );
};

export default Contacto;
